import {
  CourseQuestion,
  QuestionType,
} from '../jumpstart-communicator/jumpstart-communicator.types';

export const course_questions: CourseQuestion[] = [
  {
    id: 'e0fd0f99-f304-44e6-8a2c-30527ffaa630',
    question:
      'Question: Your supervisor has requested a report on exceptional repairs completed across the company during the past 3 months: repairs other than general maintenance. What should you do to prepare for the meeting?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'a03ec260-f8ba-4c04-ab1f-694eca5856b8',
        option: 'Summarize all scheduled repairs that took place during the past year.',
      },
      {
        id: '07d81501-e9f5-4aa0-b592-ae91a68ccc70',
        option: 'Identify whose fault each of the repairs were.',
      },
      {
        id: '216267d8-b0d6-4b86-ab94-3debe8f82f7a',
        option:
          'Summarize the past three months of repairs and confirm with each department if they were planned or exceptional.',
      },
    ],
    answers: ['216267d8-b0d6-4b86-ab94-3debe8f82f7a'],
    answer_description:
      'A great way to prepare for the meeting is to summarize the past three months of repairs and confirm with each department if they were planner or exceptional.',
    chapter_id: 'e05cce02-a347-4b76-8f05-23fa2da3114a',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
  },
  {
    id: 'e0d91beb-83ca-4dd0-a147-ca404768adfb',
    question:
      'Question: You and one other trapper are planning to repair a trap line. The east end was new last year but the west end of the line is now three years old. The weather forecast is for a snowstorm, so you need to get as much done in the shortest time possible. What is the best way to work?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '4d1e4ed4-ef20-4031-9097-ccaf69225a7e',
        option: 'One of you starts at the east end and the other at the west end.',
      },
      {
        id: '1bb72515-e2ad-4bc5-a036-e95d67f9cf6c',
        option: 'Both of you start at the part of the line you are most familiar with.',
      },
      {
        id: '86ce1eec-ea43-4523-94f7-fb152e3fab6f',
        option: 'Both of you start in different places on the west end.',
      },
    ],
    answers: ['1bb72515-e2ad-4bc5-a036-e95d67f9cf6c'],
    answer_description:
      'The best way to work is for both of you to start at the part of the line you are most familiar with.',
    chapter_id: 'e05cce02-a347-4b76-8f05-23fa2da3114a',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
  },
  {
    id: '8515d25f-9f26-45ee-bb24-d9ea78e8b15c',
    question:
      'Question: You are team leader on a baking competition to raise funds for a local non-profit. During the final round the judges will award the most points based on the appearance of the final cake. Who of your team members should you assign to create the design?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '3130c976-cea1-4b4d-9c04-8c75a18e9ff9',
        option: 'Ahmed, who is a first-time competitor but has won several awards for design.',
      },
      {
        id: '41bd7407-376a-4bc3-8853-e0fe2b8dc4f0',
        option: 'Amy, who is a flavor expert planned.',
      },
      {
        id: 'c26343ba-eba4-4495-9021-5d8b8e9cdbb7',
        option: 'Corrine, who has been in the most competitions.',
      },
    ],
    answers: ['3130c976-cea1-4b4d-9c04-8c75a18e9ff9'],
    answer_description:
      'The best way to work is for both of you to start at the part of the line you are most familiar with.',
    chapter_id: 'e05cce02-a347-4b76-8f05-23fa2da3114a',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
  },
];

export const course_quiz_questions: CourseQuestion[] = [
  {
    id: '9a4af27f-f102-41aa-991e-f8de1c14931c',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question: 'What are the four main areas of responsibility in a successful team?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '61f5c288-ef73-4d46-b28b-bc2c35f6446f',
        description: '',
        option: 'Planning, execution, evaluation, and marketing.',
      },
      {
        id: 'edde1de7-3734-4b05-b49b-008596b9f72b',
        description: '',
        option: 'Management, people care, creativity, and execution.',
      },
      {
        id: 'e46ef83c-c6f8-44e7-a93c-58662f778a34',
        option: 'Leadership, communication, problem-solving, and task completion.',
        description: '',
      },
      {
        id: '393150b7-308d-4493-9128-f5c6df259756',
        option: 'Organization, strategy, analysis, and reporting.',
        description: '',
      },
    ],
    answers: ['393150b7-308d-4493-9128-f5c6df259756'],
    wrong_answer_description:
      'The four main areas of responsibility in a successful team include: leadership, communication, problem-solving, and task completion.  ',
    answer_description:
      'The four main areas of responsibility in a successful team include: leadership, communication, problem-solving, and task completion.  ',
  },
  {
    id: '94684ffe-6f63-4f79-9b64-e542f7aa11a4',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question: 'Which role in a team focuses on keeping morale high and bringing fun to the team?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '275f12b9-c6cc-4e43-b37b-8df039dbab7e',
        description: '',
        option: 'Organizer',
      },
      {
        id: '7feebd7e-c2f9-4565-8af1-359feefe786d',
        description: '',
        option: 'Inspirer',
      },
      {
        id: '8facd9e8-f648-49e7-8f6c-cd225bff7439',
        option: 'Visionary',
        description: '',
      },
      {
        id: 'f4c13172-ce17-4069-bf43-1fcf1f9685f5',
        option: 'Carer',
        description: '',
      },
    ],
    answers: ['7feebd7e-c2f9-4565-8af1-359feefe786d'],
    wrong_answer_description:
      'The Inspirer role on a team focuses on keeping morale high and bringing fun to the team.',
    answer_description:
      'The Inspirer role on a team focuses on keeping morale high and bringing fun to the team.',
  },
  {
    id: '7635e7b8-ebaf-4b2d-82b4-ed7bdd52f7eb',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question: 'What is the role of the `Judge´ in the creativity and problem-solving area?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '6759a8d5-c86e-4245-a77f-4e1ea90e8d22',
        description: '',
        option: 'Generating new ideas',
      },
      {
        id: '4d9fe42b-94dd-41a2-9601-0e5ec2ff8613',
        description: '',
        option: 'Evaluating options and making decisions',
      },
      {
        id: '9a775ab6-ee81-4d8a-be98-2aeaa19200b3',
        option: 'Questioning the validity of ideas',
        description: '',
      },
      {
        id: '938cb5f5-a8e7-47d3-a47b-de99071077fe',
        option: 'Ensuring everything is accurate',
        description: '',
      },
    ],
    answers: ['4d9fe42b-94dd-41a2-9601-0e5ec2ff8613'],
    wrong_answer_description:
      'The role of the `Judge´ in the creativity and problem-solving area is to evaluate options and make decisions. ',
    answer_description:
      'The role of the `Judge´ in the creativity and problem-solving area is to evaluate options and make decisions. ',
  },
  {
    id: '1d8bd59c-44e7-41d9-a37f-8fc9a08e714d',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question: 'What are two behaviors that good teams generally share?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'ce9f2503-8cd9-46f2-919d-2facd1bf15ad',
        description: '',
        option: 'Everyone speaks equally and high social sensitivity.',
      },
      {
        id: 'a8e157c1-03c3-41d5-9063-77e0bf781bab',
        description: '',
        option: 'Only leaders speak and low social sensitivity.',
      },
      {
        id: '4c91f32a-025d-4a2c-b2b9-4ea9e9651d64',
        option: 'All decisions are made by one person and no need for feedback.',
        description: '',
      },
      {
        id: '734ffe27-ae7e-4ab2-9e8f-178c54463910',
        option: 'Everyone avoids conicts and works independently.',
        description: '',
      },
    ],
    answers: ['ce9f2503-8cd9-46f2-919d-2facd1bf15ad'],
    wrong_answer_description:
      'Two behaviors that good teams generally share are everyone speaks equally and high social sensitivity.',
    answer_description:
      'Two behaviors that good teams generally share are everyone speaks equally and high social sensitivity.',
  },
  {
    id: '0b119095-07b8-4648-837d-abb270b6685f',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question: 'Why is having a positive attitude important in teamwork?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'c4cce84a-4107-4ac6-bc01-a4a8c6a5c398',
        description: '',
        option: 'It ensures everyone works harder individually.',
      },
      {
        id: '00033ede-98fe-49c7-87d1-dd9f551455e3',
        description: '',
        option: 'It creates a supportive environment and helps solve problems.',
      },
      {
        id: 'aedba258-d990-4fe7-a6fc-a242b75af629',
        option: 'It eliminates the need for communication.',
        description: '',
      },
      {
        id: '49486351-3210-4c10-8c39-32148314629d',
        option: 'It guarantees individual success.',
        description: '',
      },
    ],
    answers: ['00033ede-98fe-49c7-87d1-dd9f551455e3'],
    wrong_answer_description:
      ' A positive attitude important in teamwork because it creates a supportive environment and helps solve problems.',
    answer_description:
      ' A positive attitude important in teamwork because it creates a supportive environment and helps solve problems.',
  },
  {
    id: 'ab521fb2-a324-478e-8836-b4b2f4714e9c',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question: 'Why is it important to recognize your strengths in teamwork?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'f34d9a33-07e6-4aeb-8997-885a6ba44c87',
        description: '',
        option: 'To dominate team discussions.',
      },
      {
        id: 'cc1c56b4-41e8-4144-8e34-5ecd36a9f615',
        description: '',
        option: 'To understand yourself better and improve team performance.',
      },
      {
        id: '26234db2-09e8-4153-86c4-c7a5e2d5b248',
        option: 'To avoid working on team projects.',
        description: '',
      },
      {
        id: 'afbaaef5-7564-49db-91ea-91dd86a7dac2',
        option: 'To compete with team members.',
        description: '',
      },
    ],
    answers: ['cc1c56b4-41e8-4144-8e34-5ecd36a9f615'],
    wrong_answer_description:
      'It’s important to recognize your strengths in teamwork to understand yourself better and improve team performance.',
    answer_description:
      'It’s important to recognize your strengths in teamwork to understand yourself better and improve team performance.',
  },
  {
    id: '0bcaeacf-40b8-4f35-9f62-11ec0989866f',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question: 'What should you do once you know your strengths?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '568a03dc-c0ff-4063-ac6c-c7c681959437',
        description: '',
        option: 'Keep them hidden.',
      },
      {
        id: '85f936b1-89c2-4c2b-8eff-2a8657735d64',
        description: '',
        option: 'Use them to take over team tasks.',
      },
      {
        id: '088f8d72-e913-4d49-9a1f-c9d9f6da8604',
        option: 'Look for opportunities to contribute your skills.',
        description: '',
      },
      {
        id: 'c88c9fd7-c405-447f-a661-f9d3c4a6cca5',
        option: 'Ignore them and focus on weaknesses.',
        description: '',
      },
    ],
    answers: ['088f8d72-e913-4d49-9a1f-c9d9f6da8604'],
    wrong_answer_description:
      'Once you know your strengths, look for opportunities to contribute your skills.',
    answer_description:
      'Once you know your strengths, look for opportunities to contribute your skills.',
  },
  {
    id: '95a27ff4-909a-4017-bdb3-ed31370b2306',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question: 'What is one way to manage a weakness in a team setting?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '7a344453-5bd4-4e79-bf3e-31088ac55602',
        description: '',
        option: 'Ignore it completely.',
      },
      {
        id: '15cd2789-0ef7-4e70-84b4-cf6a561e7fd6',
        description: '',
        option: 'Avoid tasks that highlight it.',
      },
      {
        id: '54887cb9-20a4-4b16-a93d-cff0db73d0b0',
        option: 'Blame others for it.',
        description: '',
      },
      {
        id: '23a3daec-eee1-4c0f-8f9b-0fb54a840ad9',
        option: 'Pretend it doesn’t exist.',
        description: '',
      },
    ],
    answers: ['15cd2789-0ef7-4e70-84b4-cf6a561e7fd6'],
    wrong_answer_description:
      'One way to manage a weakness in a team setting is to avoid tasks that highlight it.',
    answer_description:
      'One way to manage a weakness in a team setting is to avoid tasks that highlight it.',
  },
  {
    id: '736a0d2b-a270-4066-880f-f1c37c0a3a56',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question: 'Why is it benefcial to explore your weaknesses in a team?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'a37d471c-6188-4782-ac68-257e9e258b31',
        description: '',
        option: 'To highlight your faws to others.',
      },
      {
        id: 'd28e8e56-a6b5-4201-9e11-1b173c6fdab0',
        description: '',
        option: 'To let others know you can’t do much.',
      },
      {
        id: '67867e7f-33a4-49db-b5bc-e6c23916af29',
        option: 'To foster trust and improve collaboration.',
        description: '',
      },
      {
        id: 'a5481595-68f9-4bba-b193-7f9b9adb3953',
        option: 'To avoid team tasks altogether.',
        description: '',
      },
    ],
    answers: ['67867e7f-33a4-49db-b5bc-e6c23916af29'],
    wrong_answer_description:
      'It’s benefcial to explore your weaknesses in a team to foster trust and improve collaboration.',
    answer_description:
      'It’s benefcial to explore your weaknesses in a team to foster trust and improve collaboration.',
  },
  {
    id: '95468fbb-7f96-47f5-aee3-678c334d4b86',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question:
      'Why should you appreciate the strengths of team members who are different from you? ',
    type: QuestionType.RADIO,
    options: [
      {
        id: '520f0f79-ef98-4f16-afd5-64fd9e69cf64',
        description: '',
        option: 'It reduces the need for communication.',
      },
      {
        id: 'fa0db7df-455c-46cc-8e76-2a3b437f1aea',
        description: '',
        option: 'It allows you to dominate the team.',
      },
      {
        id: 'c0f428b0-3e62-4116-a3b8-71ef6afdc73c',
        option: 'It helps you use their strengths to achieve team goals.',
        description: '',
      },
      {
        id: '36f81aa7-9ee8-4187-8d84-6e64c65819d2',
        option: 'It minimizes the role o other team members.',
        description: '',
      },
    ],
    answers: ['520f0f79-ef98-4f16-afd5-64fd9e69cf64'],
    wrong_answer_description:
      'Appreciate the strengths of team members who are different from you as it helps you use their strengths to achieve team goals. ',
    answer_description:
      'Appreciate the strengths of team members who are different from you as it helps you use their strengths to achieve team goals. ',
  },
  {
    id: 'd01e85f1-d87f-4058-b136-282dbad2f66f',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question: 'What is the ultimate goal of teamwork?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'cb7aba8a-b849-43be-a3a5-149244c61307',
        description: '',
        option: 'To create synergy where collective efforts result in greater achievements.',
      },
      {
        id: 'f8a40823-110e-446c-839b-74fa8fa8feab',
        description: '',
        option: 'To allow individuals to shine more than the team.',
      },
      {
        id: '9e9c4922-00e7-4ce8-a2fa-e714907dfedc',
        option: 'To reduce the number of people needed for tasks.',
        description: '',
      },
      {
        id: 'ab73806f-00f0-46e9-88fa-22bcbf99c74f',
        option: 'To focus solely on individual success.',
        description: '',
      },
    ],
    answers: ['cb7aba8a-b849-43be-a3a5-149244c61307'],
    wrong_answer_description:
      'The ultimate goal of teamwork is to create synergy where collective efforts result in a greater achievements.',
    answer_description:
      'The ultimate goal of teamwork is to create synergy where collective efforts result in a greater achievements.',
  },
  {
    id: '20290a3b-297b-4afa-b205-a9cc00e7f055',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question:
      'Scenario: Team Project You are working on a school project with three other students. The deadline is approaching, but one of your team members, Alex, hasn’t completed their part of the work. You need Alex’s contribution to nish the project on time. What should you do?  ',
    type: QuestionType.RADIO,
    options: [
      {
        id: '011f8db4-a2cb-4948-ba94-cf80ca4af0b3',
        description: '',
        option: 'Do the work yourself to ensure it gets done.',
      },
      {
        id: '8d879c37-4e7a-46e5-be4c-bd4614fa6978',
        description: '',
        option: 'Confront Alex angrily about not doing their part.',
      },
      {
        id: '865e3297-241a-4ec8-8d02-19313ffd8c88',
        option:
          'Ask Alex if they need any help and offer to assist in completing the work together. ',
        description: '',
      },
      {
        id: 'c5b90cdc-2f00-4751-8e35-ca7987128972',
        option: 'Ignore the issue and hope Alex fnishes the work in time.',
        description: '',
      },
    ],
    answers: ['865e3297-241a-4ec8-8d02-19313ffd8c88'],
    wrong_answer_description:
      'You should ask Alex if they need any help and offer to assist in completing the work together. This approach promotes teamwork, shows empathy, and can help ensure the project is completed on time without creating confict.',
    answer_description:
      'You should ask Alex if they need any help and offer to assist in completing the work together. This approach promotes teamwork, shows empathy, and can help ensure the project is completed on time without creating confict.',
  },
  {
    id: 'f260133d-d08d-47b7-a887-06e25ff4784a',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question:
      'Scenario: Handling a Conflict During a group discussion, two of your team members, Jamie and Sam, have a disagreement about the direction of the project. The argument is getting heated, and it’s disrupting the progress of the team. How should you handle this situation?  ',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'd56aca68-4209-4c64-8bc9-fdd2e1ffac84',
        description: '',
        option: 'Take sides with the person you agree with.',
      },
      {
        id: '8888ceab-3bee-437b-b268-6625091e1eb1',
        description: '',
        option: 'Suggest taking a break and reconvening later to let everyone cool down.',
      },
      {
        id: '7054d692-2b45-4a97-97fc-2d683b1d173a',
        option: 'Ignore the argument and continue with your own work.',
        description: '',
      },
      {
        id: '0ab1d57e-df19-4cb2-a0b3-f9d3d7820e3e',
        option:
          'Mediate the discussion by allowing both Jamie and Sam to express their viewpoints and help find a common ground. ',
        description: '',
      },
    ],
    answers: ['0ab1d57e-df19-4cb2-a0b3-f9d3d7820e3e'],
    wrong_answer_description:
      'The best option is to mediate the discussion by allowing both Jamie and Sam to express their viewpoints and help find a common ground. This helps resolve the confict constructively, ensures that all voices are heard, and keeps the team focused on their goals.  ',
    answer_description:
      'The best option is to mediate the discussion by allowing both Jamie and Sam to express their viewpoints and help find a common ground. This helps resolve the confict constructively, ensures that all voices are heard, and keeps the team focused on their goals.  ',
  },
  {
    id: 'c4399ded-7ba2-44df-b0ed-ba5efe38ca5d',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question:
      'Scenario: Dividing Work Your team has been assigned a large task that needs to be broken down into smaller tasks. As the team leader, how should you decide who does what? ',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'cd3029da-2d49-4022-960d-ea662cbe0fc5',
        description: '',
        option: 'Assign tasks randomly to team members.',
      },
      {
        id: '6f237fe0-b1cd-4451-9095-fed2a39ac863',
        description: '',
        option: 'Let team members choose their tasks based on their preferences and strengths. ',
      },
      {
        id: 'e9ccf153-cb09-4ea8-99f6-247a2319b92b',
        option:
          'Assign the hardest tasks to the most capable team members and the easiest tasks to everyone else. ',
        description: '',
      },
      {
        id: 'd46cca8b-677f-4ff7-9a7c-d5b9ba3df70c',
        option: 'Do all the work yourself to ensure it’s done correctly.',
        description: '',
      },
    ],
    answers: ['6f237fe0-b1cd-4451-9095-fed2a39ac863'],
    wrong_answer_description:
      'The best option is to let team members choose their tasks based on their preferences and strengths. This approach leverages individual strengths, increases team member satisfaction, and ensures that tasks are handled by those best suited for them. ',
    answer_description:
      'The best option is to let team members choose their tasks based on their preferences and strengths. This approach leverages individual strengths, increases team member satisfaction, and ensures that tasks are handled by those best suited for them. ',
  },
  {
    id: 'fb8fc499-9add-4089-9608-ed48ed9e7940',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question:
      'Scenario: Encouraging Participation You notice that one of your team members, Taylor, is very quiet during meetings and rarely shares ideas. How can you encourage Taylor to participate more? ',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'fa0c9a9e-0616-4bf2-a18d-a2b5b76188a1',
        description: '',
        option: 'Call on Taylor directly to answer questions.',
      },
      {
        id: 'b01a6623-43e5-46c7-9975-2ab61be516f9',
        description: '',
        option: 'Ignore Taylor’s silence since they might just be shy.',
      },
      {
        id: '619287f1-2cb1-47fb-bf0f-9b997805bb09',
        option:
          'Create a safe and inclusive environment where everyone feels comfortable sharing their ideas.  ',
        description: '',
      },
      {
        id: '0b98a1e2-9e5a-4845-9de9-07c772565015',
        option: 'Tell Taylor they need to speak up more during meetings.',
        description: '',
      },
    ],
    answers: ['619287f1-2cb1-47fb-bf0f-9b997805bb09'],
    wrong_answer_description:
      'The best option is to create a safe and inclusive environment where everyone feels comfortable sharing their ideas. This approach encourages participation without putting pressure on Taylor and helps build trust within the team. ',
    answer_description:
      'The best option is to create a safe and inclusive environment where everyone feels comfortable sharing their ideas. This approach encourages participation without putting pressure on Taylor and helps build trust within the team. ',
  },
  {
    id: '309c4bfb-1830-4d42-81d5-aa9ed680dcd1',
    chapter_id: '040e1105-ef8f-4e65-b826-fabc2d6fe81c',
    course_id: '0765f8ac-4c0d-459f-a4bc-5de9cda3493c',
    question:
      'Scenario: Balancing Workloads One of your team members, Jordan, feels overwhelmed with their current workload, while another team member, Casey, has finished their tasks early and has extra time. What should you do?  ',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'fa0c9a9e-0616-4bf2-a18d-a2b5b76188a1',
        description: '',
        option: 'Ignore the imbalance and let Jordan handle it.',
      },
      {
        id: 'b01a6623-43e5-46c7-9975-2ab61be516f9',
        description: '',
        option: 'Ask Casey to help Jordan with some o their tasks.',
      },
      {
        id: '3b379434-7ac4-459e-9405-b2054346fdcf',
        option: 'Reassign some of Jordan’s tasks to yourself.  ',
        description: '',
      },
      {
        id: '98eab38f-a6d5-4ec7-986e-c7b1f65a1268',
        option: 'Criticize Jordan for not managing their time well..',
        description: '',
      },
    ],
    answers: ['b01a6623-43e5-46c7-9975-2ab61be516f9'],
    wrong_answer_description:
      'The best option is to ask Casey to help Jordan with some of their tasks. This promotes teamwork and ensures that the workload is balanced, allowing the project to move forward effciently.  ',
    answer_description:
      'The best option is to ask Casey to help Jordan with some of their tasks. This promotes teamwork and ensures that the workload is balanced, allowing the project to move forward effciently.  ',
  },
];
